import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history'
import { Helmet, HelmetProvider } from 'react-helmet-async'

import './libs/yupInit'

import App from './App'
import AppProviders from './AppProviders'
import createQueryClient from './createQueryClient'
import reportWebVitals from './reportWebVitals'
import ENVIRONMENT from './config/environment'

import { register } from 'incident-solver/build/incident-solver'

const PLACES_API_URL = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_PLACES_API_KEY}&libraries=places&language=es`

// Silencia el warning de React por el prop `testId` pasado directamente a
// elementos DOM (usado en muchos sitios como selector para QA). No se toca el
// código porque renombrarlo podría romper tests E2E externos que dependan del
// nombre actual; cualquier otro warning/error sigue mostrándose igual.
const originalConsoleError = console.error
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('React does not recognize the') &&
    args[0].includes('prop on a DOM element') &&
    args[1] === 'testId'
  ) {
    return
  }
  originalConsoleError(...args)
}

const main = async () => {
  if (ENVIRONMENT.hasMocks) {
    const { worker } = await import('./mocks/browser')
    worker.start()
  }

  const history = createBrowserHistory()
  const queryClient = createQueryClient()

  register()

  ReactDOM.render(
    <React.StrictMode>
      <HelmetProvider>
        <Helmet>
          <script async src={PLACES_API_URL}></script>
        </Helmet>
        <AppProviders history={history} queryClient={queryClient}>
          <App />
        </AppProviders>
      </HelmetProvider>
    </React.StrictMode>,
    document.getElementById('root'),
  )
}

main()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
